import type { FaireProductEntity } from "../../entity_types/product";

export const p_3yhcdrsywq: FaireProductEntity = {
  token: "p_3yhcdrsywq",
  type: "product",
  name: "Hammered Pure Copper Water Bottle 950ml",
  brandToken: "b_gs76e6ynfc",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/5fbd3db23da3bdfb4478b7dc916ec70f90bf45336901fad3fe29695b8701e91e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/69989a835b0e28ce2749968b5f74fa393e0ffd469345bce8a8610834bced8d60.jpeg",
    "https://cdn.faire.com/fastly/64fcf4f2e3896807a52fd776fbc4e370a793cc7b16f4bc99c5a415cc07c1b4a2.jpeg",
    "https://cdn.faire.com/fastly/c64328a36dac1a43a5fd7411d7189bdc6bb47f39849e8b1e80aeea8df87421dc.jpeg",
    "https://cdn.faire.com/fastly/ef519ecf8cde938ef704f15d6af4f75a94c7e42a8c373af7c418371174d4f244.jpeg",
    "https://cdn.faire.com/fastly/ae4712a5157c1cfae40e55179c44671851d4f983f6d8b475a673f8d749bcfa6e.jpeg",
  ],
  priceDollars: 32,
  description:
    "\nHand-sculpted from pure copper this is a great choice to complement an environmentally sustainable lifestyle filled with the revitalising health benefits of copper infused water. \n\nThis 950ml artisan hammered copper water bottle is a great hydration companion.\n",
  tags: [],
  msrpDollars: 64,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:21.312Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
